<div class="title p-2">
    <div class="row">
        <div class="col d-flex justify-content-start">
            <h1 class="mx-1">
                <i class="fa-solid fa-file-signature me-2"></i>
                Inregistrare Document in Registru
            </h1>
        </div>
        <div class="col d-flex justify-content-end">
            <button type="button" class="action-btn" (click)="closeDialog()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>

    <div class="row p-2">
        <div class="col">
            <form [formGroup]="form" (ngSubmit)="submitRegistruExtended()">
                <!-- Serie Selection -->
                <div class="row mb-3">
                    <div class="col">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>Serie Registru</mat-label>
                            <mat-select formControlName="serieId" [disabled]="isLoadingSeries">
                                <mat-option *ngFor="let serie of series" [value]="serie.id">
                                    {{ serie.name }}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="!form.controls['serieId'].valid && form.controls['serieId'].touched">
                                Camp obligatoriu
                            </mat-error>
                            <mat-hint *ngIf="isLoadingSeries">Se incarca seriile...</mat-hint>
                        </mat-form-field>
                    </div>
                </div>

                <!-- Number Option (only visible when serie selected and checking complete) -->
                <div class="row mb-3" *ngIf="form.controls['serieId'].value && !isCheckingNumber">
                    <div class="col">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>Optiune Numar</mat-label>
                            <mat-select formControlName="numberOption" (selectionChange)="setNumberOption($event.value)">
                                <mat-option value="new">
                                    Generare numar nou
                                </mat-option>
                                <mat-option value="existing" *ngIf="existingNumber">
                                    Foloseste numar existent: {{ existingNumber.numar }} ({{ existingNumber.data }})
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <!-- Loading indicator for number check -->
                <div class="row mb-3" *ngIf="isCheckingNumber">
                    <div class="col text-center">
                        <mat-spinner diameter="24" class="mx-auto"></mat-spinner>
                        <p class="text-muted small mt-2">Se verifica numarul existent...</p>
                    </div>
                </div>

                <!-- Valabilitate -->
                <div class="row">
                    <div class="col">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>Valabilitate (optional)</mat-label>
                            <input matInput [matDatepicker]="pickerValabil" formControlName="valability" readonly
                                (focus)="pickerValabil.open()" />
                            <mat-hint>ZZ/LL/AAAA - lasa gol daca nu e necesar</mat-hint>
                            <button mat-icon-button matSuffix type="button"
                                *ngIf="form.controls['valability'].value"
                                (click)="clearValability(); $event.stopPropagation()"
                                matTooltip="Sterge valabilitate">
                                <mat-icon>close</mat-icon>
                            </button>
                            <mat-datepicker-toggle matIconSuffix [for]="pickerValabil"></mat-datepicker-toggle>
                            <mat-datepicker #pickerValabil></mat-datepicker>
                        </mat-form-field>
                    </div>
                </div>

                <!-- Valability Quick Buttons -->
                <div class="row mb-3">
                    <div class="col d-flex justify-content-around">
                        <button type="button" class="btn btn-outline-secondary btn-sm" (click)="addMonthsToValability(12)">
                            <i class="fa-solid fa-calendar-plus me-1"></i>
                            12 luni
                        </button>
                        <button type="button" class="btn btn-outline-secondary btn-sm" (click)="addMonthsToValability(24)">
                            <i class="fa-solid fa-calendar-plus me-1"></i>
                            24 luni
                        </button>
                        <button type="button" class="btn btn-outline-danger btn-sm" (click)="clearValability()"
                            *ngIf="form.controls['valability'].value">
                            <i class="fa-solid fa-times me-1"></i>
                            Sterge
                        </button>
                    </div>
                </div>

                <!-- Action Buttons -->
                <div class="row mt-3">
                    <div class="col d-flex justify-content-between">
                        <button class="buttons" type="button" mat-flat-button (click)="closeDialog()">
                            {{ helper.dialogConfig.buttonLabels.close }}
                        </button>
                        <button class="buttons" type="submit" mat-flat-button color="primary"
                            [disabled]="form.invalid || isLoading || isLoadingSeries || isCheckingNumber">
                            <i class="fa-solid fa-check me-1"></i>
                            {{ helper.dialogConfig.buttonLabels.save }}
                        </button>
                    </div>
                </div>
            </form>
        </div>

        <!-- Loading Overlay -->
        <div class="section-spinner" *ngIf="isLoading"
            style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.5); z-index: 1000;">
            <div class="spinner" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
                <mat-spinner></mat-spinner>
                <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
            </div>
        </div>
    </div>
</div>
